import { SystemInfoFieldsTypes, SystemInfoTemplateItem } from '../../../utils/types/systemInfo';
import { SystemInfoTemplateItem as TemplateFieldItem } from '../../../utils/types/systemInfoTemplate';

export const cloneTemplateFieldsForVessel = (
  fields: TemplateFieldItem[]
): SystemInfoTemplateItem[] =>
  fields.map((item) => ({
    label: item.label,
    field: {
      type: item.field.type as SystemInfoFieldsTypes,
      value: item.field.type === 'checkBox' ? false : ''
    }
  }));
